module.exports = __webpack_public_path__ + "media/entities/2316-04bdddf0.png";